/*
  jl-card-blurb

  On a phone the card description is clamped to three lines and a tap opens the
  rest of it. Desktop keeps the clamp untouched: there several cards sit in one
  row and the fixed number of lines is what keeps their footers aligned.

  Only paragraphs that are actually cut off become tappable, so a two-line
  description does not pretend to hide anything. Whether a paragraph is cut off
  depends on the width it is laid out at, so this is re-checked on resize and
  after load, when the fonts have settled.
*/
(function () {
  var MOBILE = '(max-width: 767px)';
  var SELECTOR = '.jl-card__blurb';

  function isClamped(el) {
    var cs = window.getComputedStyle(el);
    var clamp = parseInt(cs.webkitLineClamp || cs.getPropertyValue('-webkit-line-clamp'), 10);
    var lineHeight = parseFloat(cs.lineHeight);

    // Comparing scrollHeight with clientHeight is not enough: a card that is
    // stretched to its neighbour's height gives the paragraph a taller box than
    // the three lines it shows, and the comparison then says 'nothing hidden'
    // while the clamp is still cutting the text. Measure against the clamp
    // itself instead — how many lines are shown, not how tall the box is.
    if (clamp > 0 && lineHeight > 0) {
      return el.scrollHeight > (lineHeight * clamp) + 1;
    }
    return el.scrollHeight - el.clientHeight > 1;
  }

  function reset(el) {
    el.classList.remove('is-expandable', 'is-open');
    el.removeAttribute('tabindex');
    el.removeAttribute('role');
    el.removeAttribute('aria-expanded');
  }

  function prepare(el) {
    if (!window.matchMedia(MOBILE).matches) {
      reset(el);
      return;
    }
    // An open paragraph is not clamped any more, so it stays expandable on its
    // own account rather than being measured again.
    var expandable = el.classList.contains('is-open') || isClamped(el);
    if (!expandable) {
      reset(el);
      return;
    }
    el.classList.add('is-expandable');
    el.setAttribute('tabindex', '0');
    el.setAttribute('role', 'button');
    if (!el.hasAttribute('aria-expanded')) {
      el.setAttribute('aria-expanded', el.classList.contains('is-open') ? 'true' : 'false');
    }
  }

  function prepareAll() {
    var nodes = document.querySelectorAll(SELECTOR);
    for (var i = 0; i < nodes.length; i++) prepare(nodes[i]);
  }

  function toggle(el) {
    var open = el.classList.toggle('is-open');
    el.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  document.addEventListener('click', function (event) {
    var blurb = event.target.closest && event.target.closest(SELECTOR + '.is-expandable');
    if (!blurb) return;
    toggle(blurb);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter' && event.key !== ' ' && event.key !== 'Spacebar') return;
    var blurb = event.target.closest && event.target.closest(SELECTOR + '.is-expandable');
    if (!blurb) return;
    event.preventDefault();
    toggle(blurb);
  });

  var resizeTimer = null;
  window.addEventListener('resize', function () {
    window.clearTimeout(resizeTimer);
    resizeTimer = window.setTimeout(prepareAll, 150);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', prepareAll);
  } else {
    prepareAll();
  }
  // Web fonts change the line count, so the measurement is taken again once
  // everything has loaded, and once more after the last late reflow settles.
  window.addEventListener('load', function () {
    prepareAll();
    window.setTimeout(prepareAll, 600);
  });

  // Cards rendered by the theme editor after load need the same treatment.
  document.addEventListener('shopify:section:load', prepareAll);
})();
